export default __webpack_public_path__ + "static/media/post-1.f43b8400.png";